import actions from "./actions";
import mutations from "./mutations";

const state = {
  resMasterCareerTransisition: [],
  reason_career: [],
  type_career: [],
  formInput: [],
  user_career: [],
  id: null
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
